/* eslint-disable no-unused-vars */
import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";
// creates a beautiful scrollbar
import PerfectScrollbar from "perfect-scrollbar";
import "perfect-scrollbar/css/perfect-scrollbar.css";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import { Edit } from "@material-ui/icons/";
// core components
import Navbar from "components/Navbars/Navbar.js";
import Footer from "components/Footer/Footer.js";
import Sidebar from "components/Sidebar/Sidebar.js";
import styles from "assets/jss/material-dashboard-react/layouts/adminStyle.js";
import DesktopWindows from "@material-ui/icons/DesktopWindows";
import bgImage from "assets/img/sidebar-2.jpg";
import logo from "assets/img/logo1.png";

import Parcel from "views/SubSignature2569/Parcel2569";
import GeneralAdministration from "views/SubSignature2569/GeneralAdministration2569.js";
import Pharmacy from "views/SubSignature2569/Pharmacy2569.js";
import Pathology from "views/SubSignature2569/Pathology2568.js";
import Rehab from "views/SubSignature2569/Rehab2569";
import Psychology from "views/SubSignature2569/Psychology2569";
import Welfare from "views/SubSignature2569/Welfare2569";
import Policy from "views/SubSignature2569/Policy2569";
import Finance from "views/SubSignature2569/Finance2569";
import NursingScience from "views/SubSignature2569/NursingScience2569.js";
import OPD from "views/SubSignature2569/OPD2569.js";
import IPD from "views/SubSignature2569/IPD2569.js";
import Research from "views/SubSignature2569/Research2569.js";
import Digital from "views/SubSignature2569/Digital2569.js";
import HealthInsurance from "views/SubSignature2569/HealthInsurance2569.js";
import Quality from "views/SubSignature2569/Quality2569.js";
import HumanResources from "views/SubSignature2569/HumanResources2568";
import StrategyPlans from "views/SubSignature2569/StrategyPlans2568";


let ps;

const routes = [
  {
    name: "หัวหน้างานการเงิน",
    icon: Edit,
    component: Finance,
    layout: "/SubSignature2569",
    path: "/finance"
  },
  {
    name: "หัวหน้างานพัสดุและบำรุงรักษา",
    icon: Edit,
    component: Parcel,
    layout: "/SubSignature2569",
    path: "/parcel"
  },
  {
    name: "หัวหน้ากลุ่มงานบริหารทั่วไป",
    icon: Edit,
    component: GeneralAdministration,
    layout: "/SubSignature2569",
    path: "/generaladministration"
  }
  ,
  // {
  //   name: "หัวหน้างานทรัพยากรบุคคล",
  //   icon: Edit,
  //   component: HumanResources,
  //   layout: "/SubSignature2569",
  //   path: "/humanresources"
  // },
  // {
  //   name: "หัวหน้างานยุทธศาสตร์และแผนงาน",
  //   icon: Edit,
  //   component: StrategyPlans,
  //   layout: "/SubSignature2569",
  //   path: "/strategyplans"
  // },
  {
    name: "หัวหน้ากลุ่มงานเภสัชกรรม",
    icon: Edit,
    component: Pharmacy,
    layout: "/SubSignature2569",
    path: "/pharmacy"
  },
  {
    name: "หัวหน้ากลุ่มมงานฟื้นฟูสมรรถภาพ",
    icon: Edit,
    component: Rehab,
    layout: "/SubSignature2569",
    path: "/rehab"
  },
  {
    name: "หัวหน้ากลุ่มงานจิตวิทยา",
    icon: Edit,
    component: Psychology,
    layout: "/SubSignature2569",
    path: "/psychology"
  },
  {
    name: "หัวหน้ากลุ่มงานสังคมสงเคราะห์ทางการแพทย์",
    icon: Edit,
    component: Welfare,
    layout: "/SubSignature2569",
    path: "/welfare"
  },
  {
    name: "หัวหน้ากลุ่มงานวิชาการพยาบาล",
    icon: Edit,
    component: NursingScience,
    layout: "/SubSignature2569",
    path: "/nursingscience"
  },
  {
    name: "หัวหน้ากลุ่มงานการพยาบาลผู้ป่วยใน",
    icon: Edit,
    component: IPD,
    layout: "/SubSignature2569",
    path: "/ipd"
  },
  {
    name: "หัวหน้ากลุ่มงานการพยาบาลผู้ป่วยนอก",
    icon: Edit,
    component: OPD,
    layout: "/SubSignature2569",
    path: "/opd"
  }
  ,
  {
    name: "หัวหน้ากลุ่มงานดิจิทัลการแพทย์",
    icon: Edit,
    component: Digital,
    layout: "/SubSignature2569",
    path: "/digital"
  },
  {
    name: "หัวหน้ากลุ่มงานวิจัย ถ่ายทอด และสนับสนุนวิชาการ",
    icon: Edit,
    component: Research,
    layout: "/SubSignature2569",
    path: "/research"
  },
  {
    name: "หัวหน้ากลุ่มงานพัฒนาคุณภาพ",
    icon: Edit,
    component: Quality,
    layout: "/SubSignature2569",
    path: "/quality"
  },
  {
    name: "หัวหน้ากลุ่มงานพัฒนานโยบายและยุทธศาสตร์การแพทย์",
      icon: Edit,
      component: Policy,
      layout: "/SubSignature2569",
      path: "/policy"
  },
  {
    name: "หัวหน้ากลุ่มงานประกันสุขภาพ",
      icon: Edit,
      component: HealthInsurance,
      layout: "/SubSignature2569",
      path: "/healthinsurance"
  },
  {
    name: "การลงนามคำรับรอง ฯ รองผู้อำนวยการ",
    icon: DesktopWindows,
    layout: "/signature2569",
    path: ""
  }
];

const switchRoutes = (
  <Switch>
    {routes.map((prop, key) => {
      return (
        <Route
          path={prop.layout + prop.path}
          component={prop.component}
          key={key}
        />
      );
    })}
    <Redirect from="/SubSignature2569" to="/SubSignature2569/finance" />
  </Switch>
);

const useStyles = makeStyles(styles);

export default function SubSignature2569({ ...rest }) {
  // styles
  const classes = useStyles();
  // ref to help us initialize PerfectScrollbar on windows devices
  const mainPanel = React.createRef();
  // states and functions
  const [image, setImage] = React.useState(bgImage);
  const [color, setColor] = React.useState("blue");
  const [fixedClasses, setFixedClasses] = React.useState("dropdown show");
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const handleImageClick = image => {
    setImage(image);
  };
  const handleColorClick = color => {
    setColor(color);
  };
  const handleFixedClick = () => {
    if (fixedClasses === "dropdown") {
      setFixedClasses("dropdown show");
    } else {
      setFixedClasses("dropdown");
    }
  };
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const getRoute = () => {
    return window.location.pathname !== "/admin/maps";
  };
  const resizeFunction = () => {
    if (window.innerWidth >= 960) {
      setMobileOpen(false);
    }
  };
  // initialize and destroy the PerfectScrollbar plugin
  React.useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1) {
      ps = new PerfectScrollbar(mainPanel.current, {
        suppressScrollX: true,
        suppressScrollY: false
      });
      document.body.style.overflow = "hidden";
    }
    window.addEventListener("resize", resizeFunction);
    // Specify how to clean up after this effect:
    return function cleanup() {
      if (navigator.platform.indexOf("Win") > -1) {
        ps.destroy();
      }
      window.removeEventListener("resize", resizeFunction);
    };
  }, [mainPanel]);
  return (
    <div className={classes.wrapper}>
      <Sidebar
        routes={routes}
        logoText={"การลงนามคำรับรองฯ"}
        logo={logo}
        image={image}
        handleDrawerToggle={handleDrawerToggle}
        open={mobileOpen}
        color={color}
        {...rest}
      />
      <div className={classes.mainPanel} ref={mainPanel}>
        <Navbar
          routes={routes}
          handleDrawerToggle={handleDrawerToggle}
          {...rest}
        />
        {/* On the /maps route we want the map to be on full screen - this is not possible if the content and conatiner classes are present because they have some paddings which would make the map smaller */}
        {getRoute() ? (
          <div className={classes.content}>
            <div className={classes.container}>{switchRoutes}</div>
          </div>
        ) : (
          <div className={classes.map}>{switchRoutes}</div>
        )}
        {getRoute() ? <Footer /> : null}
        {/* <FixedPlugin
          handleImageClick={handleImageClick}
          handleColorClick={handleColorClick}
          bgColor={color}
          bgImage={image}
          handleFixedClick={handleFixedClick}
          fixedClasses={fixedClasses}
        /> */}
      </div>
    </div>
  );
}
